// @ts-nocheck — verbatim port from xop-edge-staff. See src/crm/README.md.
import { useWebSocketContext } from '@crm-src/components/websocket-provider'

export const useWebSocket = () => {
  // Simply return the global WebSocket context
  return useWebSocketContext()
}

export default useWebSocket
